import React from 'react'

import { BaseView, BaseText } from '@/components/base'
import { AppIcons } from '@/components/AppIcons'
import { useTheme } from '@/hooks/useTheme'

interface AlertDescriptionProps {
  description: string
  additionalTopDescription?: string
  linkText?: string
  onPressLink?: () => void
  style?: React.CSSProperties
}

export const AlertDescription: React.FC<AlertDescriptionProps> = ({
  additionalTopDescription,
  description,
  linkText,
  onPressLink,
  style,
}) => {
  const theme = useTheme()

  // Use description color (as warningDescription might not exist in web theme)
  const sharedDescriptionStyles = {
    color: theme.colors.label.description,
    lineHeight: '20px',
  }

  return (
    <BaseView row align="flex-start" gap={6} style={style}>
      {/* Warning icon like in RN version */}
      <AppIcons name="warning" size={20} unthemedColor="#606263" />

      <BaseView flex={1} gap={20} style={{ flexShrink: 1 }}>
        {additionalTopDescription && (
          <BaseText
            fontSize={14}
            fontFamily="regular"
            color="#58595B"
            style={sharedDescriptionStyles}
          >
            {additionalTopDescription}
          </BaseText>
        )}

        <BaseText
          fontSize={16}
          fontFamily="regular"
          style={sharedDescriptionStyles}
        >
          {description}
          {linkText && (
            <>
              {' '}
              <BaseText
                fontSize={14}
                fontFamily="regular"
                color="label.buttonPrimaryEnabled"
                style={{
                  textDecorationLine: 'underline',
                  cursor: 'pointer',
                }}
                onClick={onPressLink}
              >
                {linkText}
              </BaseText>
            </>
          )}
        </BaseText>
      </BaseView>
    </BaseView>
  )
}
